<template>
	<path
		d="M1.5 4.125H14.5C14.7762 4.125 15 3.90116 15 3.625V2.375C15 2.09884 14.7762 1.875 14.5 1.875H1.5C1.22384 1.875 1 2.09884 1 2.375V3.625C1 3.90116 1.22384 4.125 1.5 4.125ZM1.5 9.125H14.5C14.7762 9.125 15 8.90116 15 8.625V7.375C15 7.09884 14.7762 6.875 14.5 6.875H1.5C1.22384 6.875 1 7.09884 1 7.375V8.625C1 8.90116 1.22384 9.125 1.5 9.125ZM1.5 14.125H14.5C14.7762 14.125 15 13.9012 15 13.625V12.375C15 12.0988 14.7762 11.875 14.5 11.875H1.5C1.22384 11.875 1 12.0988 1 12.375V13.625C1 13.9012 1.22384 14.125 1.5 14.125Z"
		fill="#E2E2E2"
	/>
</template>
